export default "__VITE_PUBLIC_ASSET__37b838c4__"